<template>
  <div class="clearfix ui_select"
       :class="{ 'active': showList, disabled: !!disabled }"
       :style="{ width: computedWidth }"
       @mouseenter="resetDropdownTimer"
       @mouseleave="startDropdownTimer"
       @scroll.stop>
    <label v-if="($slots && !hideLabel)" :for="id" class="label" :class="{hide: hideLabel}"><slot /></label>
    <div class="item--wrap"
         :id="`selectbox${id}`"
         :style="{ height: computedHeight,
                   'line-height': computedLineHeight,
                   'padding-left': computedPaddingLeft }">
      <p class="selected-item"
         @click.stop="toggleList">
        <span v-if="!activeItem && placeholder">
          {{ placeholder }}
        </span>
         <span :class="activeItem ? activeItem.cssClass : null"
                v-else>
          <span class="name"
                :style="{ 'max-width': `calc(100% - ${getAdditionalText(activeItem) ? getAdditionalText(activeItem).length * 7 : 0}px)` }">
            {{ getItemText(activeItem) }}
          </span>
          <span class="additional"
                v-if="getAdditionalText(activeItem)">
           {{ getAdditionalText(activeItem) }}
          </span>
        </span>
        <i class="icon icon--drop-down"></i>
      </p>
      <transition name="ui-selectbox-slide">
        <div class="item__list"
             :class="{ 'slide-up': slideUp }"
             :style="{ width: computedDropWidth, maxHeight: computedMaxHeight }"
             v-show="showList">
          <ul class="item__list-wrap">
            <li class="item__list-item"
                v-for="(item, index) in selectItems" :key="index"
                :class="{ on: item.value === value, 'raw-text': useRawText }"
                :title="getItemText(item)"
                @mouseenter="onMouseEnter(item.value)"
                @mouseleave="onMouseLeave(item.value)"
                @click="onChange(item.value)">
              <span class="item-name"
                    :class="[item.cssClass, {'exit': getItemText(item) === 'exit'}]"
                    :title="getItemText(item)">
                <span class="name"
                      :style="{ 'max-width': `calc(100% - ${getAdditionalText(item) ? getAdditionalText(item).length * 7 : 0}px)` }">
                  {{ getItemText(item) }}
                </span>
                <span class="additional"
                      v-if="getAdditionalText(item)">
                  {{ getAdditionalText(item) }}
                </span>
                <span v-if="item.extraNode"
                      :class="item.extraNode.className"
                      v-html="item.extraNode.html" />
              </span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { isPlainObject } from '@/libs/utils'

export default {
  name: 'UiSelectbox',
  props: [
    'value',
    'items',
    'width',
    'height',
    'dropWidth',
    'maxHeight',
    'title',
    'disabled',
    'placeholder',
    // no text-transform
    'useRawText',
    'slideUp',
    'hideLabel'
  ],
  data () {
    return {
      id: null,
      showList: false,
      dropdownTimer: null,
      dropdownTimerTime: null,
      renderedWidth: 0
    }
  },
  computed: {
    computedWidth () {
      if (!this.width && this.renderedWidth) {
        return this.renderedWidth + 'px'
      } else if (typeof this.width === 'number') {
        return this.width + 'px'
      }
      return this.width
    },
    computedHeight () {
      if (!this.height) {
        return null
      } else if (typeof this.height === 'number') {
        return this.height + 'px'
      }
      return this.height
    },
    computedPaddingLeft () {
      if (parseInt(this.computedWidth) < 100) {
        return '10px'
      }
      return null
    },
    computedLineHeight () {
      if (!this.height) {
        return null
      } else if (typeof this.height === 'number') {
        return (this.height - 4) + 'px'
      }
      return `calc(${this.height} - 4px)`
    },
    computedDropWidth () {
      if (typeof this.dropWidth === 'number') {
        return this.dropWidth + 'px'
      } else if (typeof this.width === 'number') {
        return this.width + 'px'
      } else if (!this.dropWidth && !this.width && this.renderedWidth) {
        return this.renderedWidth + 'px'
      }
      return this.dropWidth || this.width
    },
    computedMaxHeight () {
      if (typeof this.maxHeight === 'number') {
        return this.maxHeight + 'px'
      }
      return this.maxHeight
    },
    selectItems () {
      return this.items.map(item => {
        if (!isPlainObject(item)) {
          return {
            value: item
          }
        }
        return item
      })
    },
    activeItem () {
      return this.selectItems.find(item => item.value === this.value)
    }
  },
  watch: {
    showList (value) {
      let bodyListener = (e) => {
        let outside = true

        function composedPath (el) {
          let paths = []
          while (el) {
            paths.push(el)
            if (el.tagName === 'HTML') {
              paths.push(document)
              paths.push(window)
              return paths
            }
            el = el.parentElement
          }
        }

        const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target)
        if (path) {
          for (const el of path) {
            if (el.id && el.id === `selectbox${this.id}`) {
              outside = false
            }
          }
        }
        if (outside) {
          this.showList = false
        }
      }

      if (value) {
        document.body.addEventListener('click', bodyListener, false)
      } else {
        this.$emit('mouseleave')
        document.body.removeEventListener('click', bodyListener)
      }
    }
  },
  mounted () {
    this.id = this._uid
    this.renderedWidth = this.$el.offsetWidth
    EventBus.$on('closeAllUiSelectBox', () => {
      this.showList = false
    })
  },
  methods: {
    startDropdownTimer: function () {
      this.dropdownTimer = setInterval(() => {
        if (this.dropdownTimerTime < 3) {
          this.showList = false
        }
        this.dropdownTimerTime--
      }, 1000)
    },
    resetDropdownTimer: function () {
      this.dropdownTimerTime = 3
      clearInterval(this.dropdownTimer)
      this.dropdownTimer = null
    },
    toggleList () {
      if (this.disabled) {
        return
      }
      const willShow = !this.showList
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeJourneyPageList')
      this.$emit('click')
      this.showList = willShow
      if (!this.showList) {
        this.resetDropdownTimer()
      }
      this.$emit('toggle', this.showList)
    },
    onChange (value) {
      this.showList = false
      this.$emit('input', value)
      this.$emit('changed')
    },
    onMouseEnter (value) {
      this.$emit('mouseenter', value)
    },
    onMouseLeave (value) {
      this.$emit('mouseleave', value)
    },
    getItemText (item) {
      if (!item) {
        return ''
      }
      return String(item.i18n || (item.text || item.value))
    },
    getAdditionalText (item) {
      if (!item || !item.additionalText) {
        return null
      }
      return String(item.additionalText)
    }
  }
}
</script>

<style lang="scss">
.ui_select {
  cursor: pointer;
  text-align: left;
  display: inline-block;

  .label {
    display: inline-block;
    font-weight: 500;
    padding-left: 5px;
    margin-bottom: 5px;
    font-size: 13px;
    color: #767676;
  }

  &.disabled {
    pointer-events: none;
    .item--wrap{
      background-color:#d7d7d7;
      opacity: 0.3;
    }
  }

  .item--wrap {
    position: relative;
    padding-left: 8px;
    display: inline-block;
    width: 100%;
    height: 38px;
    line-height: 36px;
    border-radius: 5px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    box-sizing: border-box;
    font-size: 14px;
    color: #2f2f2f;

    .selected-item {
      color: #2f2f2f;
      position: relative;
      height: 100%;

      &>span {
        display: flex;
        margin-right: 35px;
      }

      .icon {
        pointer-events: none;
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
      }

      .name {
        max-width: 100%;
        vertical-align: middle;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .additional {
        margin-left: 0.5ch;
        vertical-align: middle;
        display: inline-block;
      }
    }

    .item__list {
      width: 100%;
      position: absolute;
      top: -1px;
      left: -1px;
      background-color: #fff;
      z-index: 10000001;
      border-radius: 6px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.25);
      line-height: 36px;
      transform: scaleY(1);
      opacity: 1;
      transform-origin: top;
      transition: transform 0.2s ease, opacity 0.1s ease;
      box-sizing: border-box;
      overflow: hidden;

      &.slide-up {
        transform-origin: bottom;
        top: auto;
        bottom: -1px;
      }

      .item__list-wrap {
        max-height: 320px;
        overflow-y: auto;
      }

      &.ui-selectbox-slide-enter,
      &.ui-selectbox-slide-leave-to{
        transform: scaleY(0);
        opacity: 0;
      }

      .item__list-item {
        padding-left: 8px;
        height: 38px;
        color: #444;
        cursor: pointer;

        &.raw-text {
          text-transform: none;
        }

        &.on {
          background-color: #f4f4f4;
        }

        &:hover {
          background-color: #ebebeb;
        }

        .item-name {
          display: block;
          margin-right: 10px;
          white-space: nowrap;

          &.exit {
            text-transform: capitalize;
          }

          .name {
            max-width: 100%;
            vertical-align: middle;
            display: inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .additional {
            margin-left: 0.5ch;
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
